<template>
  <div class="user-register">
    <div class="user-register-container">
      <div class="user-register-header">
        <p class="left">
          <img :src="logo" alt class="logo" />
          <span class="welcome">欢迎注册</span>
        </p>
        <p class="right">
          <span class="gray">已有账号？</span>
          <span class="red" @click="login">请登录&gt;</span>
        </p>
      </div>
      <div class="user-register-main">
        <div v-if="steps===3" class="steps3">
          <svg
            viewBox="0 0 1024 1024"
            version="1.1"
            xmlns="http://www.w3.org/2000/svg"
            p-id="3338"
            xmlns:xlink="http://www.w3.org/1999/xlink"
            width="160"
            height="160"
          >
            <path
              d="M512.697 75.444c-247.54 0-448.208 200.668-448.208 448.208s200.668 448.208 448.208 448.208c247.54 0 448.208-200.668 448.208-448.208 0-247.54-200.668-448.208-448.208-448.208zM782.651 398.325l-310.141 316.86c-1.057 1.586-2.234 3.101-3.62 4.505-12.156 12.346-31.862 12.346-44.026 0l-154.053-156.424c-12.147-12.347-12.147-32.355 0-44.684 12.155-12.347 31.861-12.347 44.016 0l131.584 133.592 292.213-298.55c12.165-12.346 31.862-12.346 44.026 0 12.147 12.346 12.147 32.353 0 44.701z"
              p-id="3339"
              fill="#DF3445"
            />
          </svg>
          <p>恭喜你，注册成功！</p>
          <el-button @click="goLogin">返回登录</el-button>
        </div>
        <div v-else>
          <el-steps :active="steps" align-center>
            <el-step title="验证手机号"></el-step>
            <el-step title="填写信息"></el-step>
            <el-step title="注册完成"></el-step>
          </el-steps>
          <el-form ref="phoneForm" :model="phoneForm" v-if="steps===1">
            <el-form-item>
              <el-input class="xb-gray" v-model="phoneForm.phone" placeholder="请输入手机号"></el-input>
            </el-form-item>
            <el-form-item>
              <div class="drag" ref="dragDiv">
                <div class="drag_bg"></div>
                <div class="drag_text">{{confirmWords}}</div>
                <div
                  ref="moveDiv"
                  @mousedown="mousedownFn($event)"
                  :class="{'handler_ok_bg':confirmSuccess}"
                  class="handler handler_bg"
                  style="position: absolute;top: 0px;left: 0px;"
                ></div>
              </div>
            </el-form-item>
            <el-form-item>
              <el-input v-model.number="phoneForm.code" class="xb-gray w180" placeholder="请输入验证码"></el-input>
              <el-button
                :class="disabled?'send color':'send' "
                @click="sendCode"
                :disabled="disabled"
              >{{btntxt}}</el-button>
            </el-form-item>
            <el-form-item>
              <el-button class="btn-next" @click="next">下一步</el-button>
            </el-form-item>
          </el-form>
          <el-form
            ref="messageForm"
            :rules="rules"
            :model="messageForm"
            v-show="steps===2"
            class="messageForm"
          >
            <el-form-item prop="username">
              <el-input class="xb-gray" v-model="messageForm.username" placeholder="请输入用户名"></el-input>
            </el-form-item>
            <el-form-item prop="password">
              <el-input
                class="xb-gray"
                v-model="messageForm.password"
                type="password"
                placeholder="请输入密码"
              ></el-input>
            </el-form-item>
            <el-form-item prop="checkword">
              <el-input
                class="xb-gray"
                v-model="messageForm.checkword"
                type="password"
                placeholder="请再次输入密码"
              ></el-input>
            </el-form-item>
            <template v-show="companyRegister===1">
              <el-form-item prop="component">
                <el-input
                  class="xb-gray"
                  prop="component"
                  v-model="messageForm.component"
                  placeholder="请输入公司名称"
                ></el-input>
              </el-form-item>
              <el-form-item prop="person">
                <el-input class="xb-gray" v-model="messageForm.person" placeholder="请输入联系人"></el-input>
              </el-form-item>
            </template>
            <el-form-item prop="address">
              <el-cascader
                v-model="messageForm.address"
                :options="address"
                :props="defaultParams"
                @change="handleChange"
                class="xb-gray"
                placeholder="所在区域"
                filterable
              ></el-cascader>
            </el-form-item>
            <el-form-item prop="detailAddress">
              <el-input class="xb-gray" v-model="messageForm.detailAddress" placeholder="详细地址"></el-input>
            </el-form-item>
            <el-form-item prop="pron" v-show="moduleInvitation == 1?true:false">
              <el-input class="xb-gray" v-model="messageForm.pron" placeholder="请输入邀请码（非必填）"></el-input>
            </el-form-item>
            <el-form-item prop="qq">
              <el-input class="xb-gray" v-model="messageForm.qq" :placeholder="qqPlaceHolder"></el-input>
            </el-form-item>
            <el-form-item>
              <el-button class="btn-next" @click="submit">完成</el-button>
            </el-form-item>
          </el-form>
        </div>
      </div>
    </div>
    <div class="footer">
      <p class="code">
        <a href="http://www.beian.miit.gov.cn" target="_blank">{{ code }}</a>
      </p>
      <p class="ydb">由亿店宝提供技术支持</p>
    </div>
  </div>
</template>

<script>
import { getXBBasicInformation } from "common/js/storage";
import XBUser from "models/xb/user.js";
import XBAddress from "models/xb/address.js";
const xbUser = new XBUser();
const xbAddress = new XBAddress();

export default {
  data() {
    return {
      steps: 1,
      phoneForm: {
        phone: "",
        code: ""
      },
      qqPlaceHolder: '请输入QQ号（非必填）',
      disabled: false,
      btntxt: "发送验证码",
      time: 0,
      messageForm: {
        username: "",
        password: "",
        checkword: "",
        component: null,
        person: null,
        address: [],
        detailAddress: "",
        pron: "",
        qq: ""
      },
      rules: {
        username: [
          { required: true, message: "请输入用户名", trigger: "blur" }
        ],
        password: [{ required: true, message: "请输入密码", trigger: "blur" }],
        checkword: [{ required: true, message: "请确认密码", trigger: "blur" }],
        component: [
          { required: true, message: "请输入公司名称", trigger: "blur" }
        ],
        person: [{ required: true, message: "请输入联系人", trigger: "blur" }],
        address: [{ required: true, message: "请选择地址", trigger: "change" }],
        detailAddress: [
          { required: true, message: "请输入详细地址", trigger: "blur" }
        ]
      },
      companyRegister: 1, // 是否开启企业注册
      address: [] /* 地址列表 */,
      defaultParams: {
        label: "name",
        value: "id",
        children: "children"
      }, // 联级格式
      beginClientX: 0 /* 距离屏幕左端距离 */,
      mouseMoveStata: false /* 触发拖动状态  判断 */,
      maxwidth: "" /* 拖动最大宽度，依据滑块宽度算出来的 */,
      confirmWords: "拖动滑块验证" /* 滑块文字 */,
      confirmSuccess: false /* 验证成功判断 */,
      logo: "",
      code: "",
      moduleInvitation: ''
    };
  },
  created() {
    this.basicInformation();
    this.moduleInvitation = getXBBasicInformation().moduleInvitation
    xbAddress.getXBAddressMock().then(res => {
      this.address = res;
    });
    if (window.location.host == 'www.it-nd.com') {
      this.qqPlaceHolder = '请输入QQ号'
      this.rules.qq = [
        { required: true, message: "请输入QQ号", trigger: "blur" }
      ]
    }
  },
  methods: {
    handleChange(val) {
      console.log(val);
    },
    // 返回登录
    login() {
      this.$router.push("/user-login");
    },
    // 滑块动画
    mousedownFn(e) {
      if (!this.confirmSuccess) {
        e.preventDefault && e.preventDefault(); // 阻止文字选中等 浏览器默认事件
        this.mouseMoveStata = true;
        this.beginClientX = e.clientX;
      }
    }, // mousedoen 事件
    successFunction() {
      this.confirmSuccess = true;
      this.confirmWords = "验证通过";
      if (window.addEventListener) {
        document
          .getElementsByTagName("html")[0]
          .removeEventListener("mousemove", this.mouseMoveFn);
        document
          .getElementsByTagName("html")[0]
          .removeEventListener("mouseup", this.moseUpFn);
      } else {
        document
          .getElementsByTagName("html")[0]
          .removeEventListener("mouseup", () => {});
      }
      document.getElementsByClassName("drag_text")[0].style.color = "#fff";
      document.getElementsByClassName("handler")[0].style.left =
        this.maxwidth + "px";
      document.getElementsByClassName("drag_bg")[0].style.width =
        this.maxwidth + "px";
    }, // 验证成功函数
    mouseMoveFn(e) {
      if (this.mouseMoveStata) {
        let width = e.clientX - this.beginClientX;
        if (width > 0 && width <= this.maxwidth) {
          document.getElementsByClassName("handler")[0].style.left =
            width + "px";
          document.getElementsByClassName("drag_bg")[0].style.width =
            width + "px";
        } else if (width > this.maxwidth) {
          this.successFunction();
        }
      }
    }, // mousemove事件
    moseUpFn(e) {
      this.mouseMoveStata = false;
      var width = e.clientX - this.beginClientX;
      if (width < this.maxwidth) {
        document.getElementsByClassName("handler")[0].style.left = 0 + "px";
        document.getElementsByClassName("drag_bg")[0].style.width = 0 + "px";
      }
    }, // mouseup事件
    // 发送验证码
    sendCode() {
      const reg = 11 && /^((13|14|15|16|17|18|19)[0-9]{1}\d{8})$/;
      if (this.phoneForm.phone === "") {
        this.$message({
          message: "手机号不能为空",
          center: true
        });
        return;
      }
      if (!reg.test(this.phoneForm.phone)) {
        this.$message({
          message: "请输入正确的手机号",
          center: true
        });
      } else {
        if (this.confirmSuccess) {
          let telephone = this.phoneForm.phone;
          xbUser.getXBRegisterSendCode(telephone).then(res => {
            if (res.success) {
              this.$message({
                message: "发送成功",
                type: "success",
                center: true
              });
              this.time = 60;
              this.disabled = true;
              this.timer();
            } else {
              this.$message.error(res.message);
            }
          });
        } else {
          this.$message({
            message: "请拖动滑块验证",
            center: true
          });
        }
      }
    },
    // 60S倒计时
    timer() {
      if (this.time > 0) {
        this.time--;
        this.btntxt = this.time + "s后重试";
        setTimeout(this.timer, 1000);
      } else {
        this.time = 0;
        this.btntxt = "获取验证码";
        this.disabled = false;
      }
    },
    // 点击下一步核对验证码
    next() {
      let telephone = this.phoneForm.phone;
      let code = this.phoneForm.code;
      if (telephone && code && this.confirmSuccess) {
        xbUser.getXBCheckCode(telephone, code).then(res => {
          if (res.success) {
            this.steps = 2;
            xbUser.getXBBusiness().then(res => {
              if (res.success) {
                this.companyRegister = res.result.companyRegister;
              }
            });
          } else {
            this.$message.error(res.message);
          }
        });
      } else {
        this.$message.error("手机号或验证码不能为空");
      }
    },
    // 用户注册表单上传
    submit() {
      let surePassword = this.messageForm.checkword;
      let contact = this.messageForm.person;
      let name = this.messageForm.component;
      let inviteCode = this.messageForm.pron;
      let qq = this.messageForm.qq;
      let province = this.messageForm.address[0];
      let city = this.messageForm.address[1]
        ? this.messageForm.address[1]
        : null;
      let regions = this.messageForm.address[2]
        ? this.messageForm.address[2]
        : null;
      let address = this.messageForm.detailAddress;
      let username = this.messageForm.username;
      let password = this.messageForm.password;
      let telephone = this.phoneForm.phone;
      let code = this.phoneForm.code;
      let data = {
        username,
        password,
        telephone,
        code
      };
      this.$refs["messageForm"].validate(valid => {
        if (valid) {
          if (password === surePassword) {
            xbUser
              .postXBRegister(
                surePassword,
                contact,
                name,
                inviteCode,
                qq,
                province,
                city,
                regions,
                address,
                data
              )
              .then(res => {
                if (res.success) {
                  this.steps = 3;
                } else {
                  this.$message.error(res.message);
                }
              });
          } else {
            this.$message.error("两次密码不匹配");
          }
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
    // 返回登录
    goLogin() {
      this.$router.push("/user-login");
    },
    // 获取基础信息
    basicInformation() {
      let res = getXBBasicInformation();
      this.logo = res.logo;
      this.code = res.companyNumber;
    }
  },
  mounted() {
    this.maxwidth =
      this.$refs.dragDiv.clientWidth - this.$refs.moveDiv.clientWidth;
    document
      .getElementsByTagName("html")[0]
      .addEventListener("mousemove", this.mouseMoveFn);
    document
      .getElementsByTagName("html")[0]
      .addEventListener("mouseup", this.moseUpFn);
  }
};
</script>
<style lang='scss' scoped>
.user-register {
  min-height: 100vh;
  background: #fff;
  overflow: hidden;
  .user-register-container {
    width: 1200px;
    margin: 0 auto;
    .user-register-header {
      box-sizing: border-box;
      height: 150px;
      padding: 70px 20px 30px 20px;
      display: flex;
      align-items: flex-end;
      justify-content: space-between;
      border-bottom: 1px solid#E4E4E4;
      .left {
        display: flex;
        align-items: flex-end;
        .logo {
          width: 150px;
          margin-right: 24px;
        }
        .welcome {
          color: rgba(96, 98, 102, 1);
          line-height: 33px;
          letter-spacing: 2px;
          font-size: 24px;
        }
      }
      .right {
        font-size: 14px;
        .gray {
          color: #919398;
        }
        .red {
          color: #df3445;
          cursor: pointer;
        }
      }
    }
    .user-register-main {
      width: 700px;
      margin: 0 auto;
      padding-top: 40px;
      padding-bottom: 30px;
      .steps3 {
        display: flex;
        flex-direction: column;
        align-items: center;
        svg {
          margin-bottom: 60px;
        }
        p {
          font-size: 16px;
          color: rgba(96, 98, 102, 1);
          line-height: 22px;
          letter-spacing: 2px;
          margin-bottom: 38px;
        }
        .el-button {
          width: 160px;
          height: 40px;
          background: rgba(223, 52, 69, 1);
          border-radius: 4px;
          color: rgba(255, 255, 255, 1);
          letter-spacing: 2px;
          padding: 0;
        }
      }
    }
    .drag {
      position: relative;
      background-color: #e8e8e8;
      width: 100%;
      height: 40px;
      line-height: 40px;
      text-align: center;
    }
    .handler {
      box-sizing: border-box;
      width: 40px;
      height: 40px;
      border: 1px solid #ccc;
      cursor: move;
    }
    .handler_bg {
      background: #fff
        url("data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAYAAAAf8/9hAAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAA3hpVFh0WE1MOmNvbS5hZG9iZS54bXAAAAAAADw/eHBhY2tldCBiZWdpbj0i77u/IiBpZD0iVzVNME1wQ2VoaUh6cmVTek5UY3prYzlkIj8+IDx4OnhtcG1ldGEgeG1sbnM6eD0iYWRvYmU6bnM6bWV0YS8iIHg6eG1wdGs9IkFkb2JlIFhNUCBDb3JlIDUuNS1jMDIxIDc5LjE1NTc3MiwgMjAxNC8wMS8xMy0xOTo0NDowMCAgICAgICAgIj4gPHJkZjpSREYgeG1sbnM6cmRmPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5LzAyLzIyLXJkZi1zeW50YXgtbnMjIj4gPHJkZjpEZXNjcmlwdGlvbiByZGY6YWJvdXQ9IiIgeG1sbnM6eG1wTU09Imh0dHA6Ly9ucy5hZG9iZS5jb20veGFwLzEuMC9tbS8iIHhtbG5zOnN0UmVmPSJodHRwOi8vbnMuYWRvYmUuY29tL3hhcC8xLjAvc1R5cGUvUmVzb3VyY2VSZWYjIiB4bWxuczp4bXA9Imh0dHA6Ly9ucy5hZG9iZS5jb20veGFwLzEuMC8iIHhtcE1NOk9yaWdpbmFsRG9jdW1lbnRJRD0ieG1wLmRpZDo0ZDhlNWY5My05NmI0LTRlNWQtOGFjYi03ZTY4OGYyMTU2ZTYiIHhtcE1NOkRvY3VtZW50SUQ9InhtcC5kaWQ6NTEyNTVEMURGMkVFMTFFNEI5NDBCMjQ2M0ExMDQ1OUYiIHhtcE1NOkluc3RhbmNlSUQ9InhtcC5paWQ6NTEyNTVEMUNGMkVFMTFFNEI5NDBCMjQ2M0ExMDQ1OUYiIHhtcDpDcmVhdG9yVG9vbD0iQWRvYmUgUGhvdG9zaG9wIENDIDIwMTQgKE1hY2ludG9zaCkiPiA8eG1wTU06RGVyaXZlZEZyb20gc3RSZWY6aW5zdGFuY2VJRD0ieG1wLmlpZDo2MTc5NzNmZS02OTQxLTQyOTYtYTIwNi02NDI2YTNkOWU5YmUiIHN0UmVmOmRvY3VtZW50SUQ9InhtcC5kaWQ6NGQ4ZTVmOTMtOTZiNC00ZTVkLThhY2ItN2U2ODhmMjE1NmU2Ii8+IDwvcmRmOkRlc2NyaXB0aW9uPiA8L3JkZjpSREY+IDwveDp4bXBtZXRhPiA8P3hwYWNrZXQgZW5kPSJyIj8+YiRG4AAAALFJREFUeNpi/P//PwMlgImBQkA9A+bOnfsIiBOxKcInh+yCaCDuByoswaIOpxwjciACFegBqZ1AvBSIS5OTk/8TkmNEjwWgQiUgtQuIjwAxUF3yX3xyGIEIFLwHpKyAWB+I1xGSwxULIGf9A7mQkBwTlhBXAFLHgPgqEAcTkmNCU6AL9d8WII4HOvk3ITkWJAXWUMlOoGQHmsE45ViQ2KuBuASoYC4Wf+OUYxz6mQkgwAAN9mIrUReCXgAAAABJRU5ErkJggg==")
        no-repeat center;
    }
    .handler_ok_bg {
      background: #fff
        url("data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAYAAAAf8/9hAAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAA3hpVFh0WE1MOmNvbS5hZG9iZS54bXAAAAAAADw/eHBhY2tldCBiZWdpbj0i77u/IiBpZD0iVzVNME1wQ2VoaUh6cmVTek5UY3prYzlkIj8+IDx4OnhtcG1ldGEgeG1sbnM6eD0iYWRvYmU6bnM6bWV0YS8iIHg6eG1wdGs9IkFkb2JlIFhNUCBDb3JlIDUuNS1jMDIxIDc5LjE1NTc3MiwgMjAxNC8wMS8xMy0xOTo0NDowMCAgICAgICAgIj4gPHJkZjpSREYgeG1sbnM6cmRmPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5LzAyLzIyLXJkZi1zeW50YXgtbnMjIj4gPHJkZjpEZXNjcmlwdGlvbiByZGY6YWJvdXQ9IiIgeG1sbnM6eG1wTU09Imh0dHA6Ly9ucy5hZG9iZS5jb20veGFwLzEuMC9tbS8iIHhtbG5zOnN0UmVmPSJodHRwOi8vbnMuYWRvYmUuY29tL3hhcC8xLjAvc1R5cGUvUmVzb3VyY2VSZWYjIiB4bWxuczp4bXA9Imh0dHA6Ly9ucy5hZG9iZS5jb20veGFwLzEuMC8iIHhtcE1NOk9yaWdpbmFsRG9jdW1lbnRJRD0ieG1wLmRpZDo0ZDhlNWY5My05NmI0LTRlNWQtOGFjYi03ZTY4OGYyMTU2ZTYiIHhtcE1NOkRvY3VtZW50SUQ9InhtcC5kaWQ6NDlBRDI3NjVGMkQ2MTFFNEI5NDBCMjQ2M0ExMDQ1OUYiIHhtcE1NOkluc3RhbmNlSUQ9InhtcC5paWQ6NDlBRDI3NjRGMkQ2MTFFNEI5NDBCMjQ2M0ExMDQ1OUYiIHhtcDpDcmVhdG9yVG9vbD0iQWRvYmUgUGhvdG9zaG9wIENDIDIwMTQgKE1hY2ludG9zaCkiPiA8eG1wTU06RGVyaXZlZEZyb20gc3RSZWY6aW5zdGFuY2VJRD0ieG1wLmlpZDphNWEzMWNhMC1hYmViLTQxNWEtYTEwZS04Y2U5NzRlN2Q4YTEiIHN0UmVmOmRvY3VtZW50SUQ9InhtcC5kaWQ6NGQ4ZTVmOTMtOTZiNC00ZTVkLThhY2ItN2U2ODhmMjE1NmU2Ii8+IDwvcmRmOkRlc2NyaXB0aW9uPiA8L3JkZjpSREY+IDwveDp4bXBtZXRhPiA8P3hwYWNrZXQgZW5kPSJyIj8+k+sHwwAAASZJREFUeNpi/P//PwMyKD8uZw+kUoDYEYgloMIvgHg/EM/ptHx0EFk9I8wAoEZ+IDUPiIMY8IN1QJwENOgj3ACo5gNAbMBAHLgAxA4gQ5igAnNJ0MwAVTsX7IKyY7L2UNuJAf+AmAmJ78AEDTBiwGYg5gbifCSxFCZoaBMCy4A4GOjnH0D6DpK4IxNSVIHAfSDOAeLraJrjgJp/AwPbHMhejiQnwYRmUzNQ4VQgDQqXK0ia/0I17wJiPmQNTNBEAgMlQIWiQA2vgWw7QppBekGxsAjIiEUSBNnsBDWEAY9mEFgMMgBk00E0iZtA7AHEctDQ58MRuA6wlLgGFMoMpIG1QFeGwAIxGZo8GUhIysmwQGSAZgwHaEZhICIzOaBkJkqyM0CAAQDGx279Jf50AAAAAABJRU5ErkJggg==")
        no-repeat center;
    }
    .drag_bg {
      background-color: #7ac23c;
      height: 40px;
      width: 0px;
    }
    .drag_text {
      position: absolute;
      top: 0px;
      width: 100%;
      text-align: center;
      -moz-user-select: none;
      -webkit-user-select: none;
      user-select: none;
      -o-user-select: none;
      -ms-user-select: none;
    }
  }
  .footer {
    position: absolute;
    bottom: 10px;
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    p {
      font-size: 12px;
      color: #a4a4a4;
      line-height: 12px;
      padding: 0 10px;
    }
    .ydb {
      border-left: 1px solid #a4a4a4;
    }
    .code {
      cursor: pointer;
      a {
        color: #a4a4a4;
        outline: none;
      }
    }
  }
}
</style>
<style lang="scss">
.user-register {
  .user-register-container {
    .user-register-main {
      .el-steps {
        .el-step__line {
          top: 15px;
        }
        .el-step__icon {
          width: 32px;
          height: 32px;
        }
        .el-step__head.is-finish {
          color: #fff;
          font-size: 16px;
          border-color: #3d74f2;
          .el-step__icon {
            background: #3d74f2;
          }
        }
        .el-step__head.is-process {
          color: #fff;
          font-size: 16px;
          border-color: #c0c4cc;
          .el-step__icon {
            background: #c0c4cc;
          }
        }
        .el-step__head.is-wait {
          color: #fff;
          font-size: 16px;
          border-color: #c0c4cc;
          .el-step__icon {
            background: #c0c4cc;
          }
        }
        .el-step__main {
          .is-finish {
            color: #3d74f2;
          }
          .is-process {
            color: #c0c4cc;
            font-weight: 400;
          }
          .is-await {
            color: #c0c4cc;
            font-weight: 400;
          }
        }
      }
      .el-form {
        padding-top: 42px;
        width: 320px;
        margin: 0 auto;
        .el-form-item {
          margin-bottom: 40px;
          .w180 {
            width: 180px;
          }
          .send {
            width: 120px;
            height: 40px;
            background: rgba(223, 52, 69, 1);
            border-radius: 4px;
            color: rgba(255, 255, 255, 1);
            letter-spacing: 4px;
            padding: 0;
            border: 0px;
            margin-left: 20px;
          }
          .send:hover {
            background: #de1f1a;
          }
          .send.color {
            background: #c0c4cc;
          }
          .send.color:hover {
            background: #c0c4cc;
          }
          .btn-next {
            width: 320px;
            height: 40px;
            background: rgba(223, 52, 69, 1);
            border-radius: 4px;
            color: rgba(255, 255, 255, 1);
            letter-spacing: 4px;
          }
          .el-cascader.xb-gray .el-input--suffix .el-input__inner {
            width: 320px;
          }
        }
      }
      .el-form.messageForm {
        .el-form-item {
          margin-bottom: 30px;
        }
      }
    }
  }
}
</style>
